import { useCallback } from "react";
import useU2000AxiosAuthenticated from "../u2000Core/axios/U2000UseAxiosAuthenticated";
import { doApprove, type U3130ApproveRequestBody } from "./U3130Service";
import type { U3130Timesheet } from "./U3130TimesheetModel";

/** Champs optionnels POST approve (salarié et/ou horaire — le backend ignore l’inutile). */
export type U3130ApproveOptionalPayload = Partial<
  Pick<
    U3130ApproveRequestBody,
    | "totalHours"
    | "totalPaidHours"
    | "unpaidHours"
    | "regularHoursToBank"
    | "halfTimeHoursToBank"
    | "doubleTimeHoursToBank"
  >
>;

export function useU3130ApproveHandlers() {
  const axios = useU2000AxiosAuthenticated();

  const approve = useCallback(
    async (timesheetId: string, version: number, optionalPayload?: U3130ApproveOptionalPayload): Promise<U3130Timesheet> => {
      const body: U3130ApproveRequestBody = {
        id: timesheetId,
        version,
        ...optionalPayload,
      };
      const res = await doApprove(axios, timesheetId, body);
      const raw = res.data?.result ?? res.data;
      return raw as U3130Timesheet;
    },
    [axios],
  );

  return { approve };
}
